<template>
  <div :class="['relative', sizeClass]">
    <div class="logo" />
    <div class="logo-text" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  size: {
    type: String,
    default: "large",
  },
});

const sizeClass = computed(() => {
  if (props.size === "small") {
    return "w-16 h-16";
  }

  if (props.size === "medium") {
    return "w-24 h-24";
  }

  return "w-32 h-32";
});
</script>

<style scoped>
.logo {
  --r1: 154%;
  --r2: 68.5%;
  --loader-primary: var(--p-primary-color, var(--p-primary-900, #172033));
  --loader-primary-soft: var(--p-primary-100, #e8e9eb);
  width: 100%;
  height: 100%;
  background:
    radial-gradient(var(--r1) var(--r2) at bottom, var(--loader-primary) 79.5%, #0000 80%),
    var(--loader-primary-soft);
  background-size: 50.5% 220%;
  background-position: -100% 0%, 0% 0%, 100% 0%;
  background-repeat: repeat;
  -webkit-mask: url('~/assets/icons/ocv-logo-vert.svg') center / contain no-repeat;
  mask: url('~/assets/icons/ocv-logo-vert.svg') center / contain no-repeat;
  animation: logoWave 4s infinite linear;
  position: absolute;
  top: 0;
  left: 0;
}

.logo-text {
  width: 100%;
  height: 100%;
  background: var(--p-primary-inverse, #ffffff);
  -webkit-mask: url('~/assets/icons/ocv-logo-text.svg') center / contain no-repeat;
  mask: url('~/assets/icons/ocv-logo-text.svg') center / contain no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1; /* Above the animated logo */
}

@keyframes logoWave {
  50% { background-position: 400% 100% }
  100% { background-position: 800% 0% }
}
</style>
